import axios from 'axios';
import config from  '../config/config.json';

export const auth = (obj) => {
    const env = process.env.NODE_ENV || 'development';
    const apiUrl = config[env].REACT_APP_API_URL;
    return axios.post(`${apiUrl}/auth`, obj);
}